import { createAction } from '@ngrx/store';

export enum AuthActionTypes {
  USER_LOGGED_IN = '[Auth] User Logged In',
  USER_LOGGED_OUT = '[Auth] User Logged Out',
}

export const userLoggedIn = createAction(AuthActionTypes.USER_LOGGED_IN);
export const userLoggedOut = createAction(AuthActionTypes.USER_LOGGED_OUT);
